import { useQuery } from "@tanstack/react-query";
import {
  getAccountsDashboard,
  getChannelEffectiveness,
  getDashboardCampaignPerformance,
  getDealsSummary,
  getTopPerformingCampaigns,
  getSimilarAccountTargets,
  getUpcomingMeetings,
} from "../api/dashboardApi";

export const useGetUpcomingMeetings = ({
  days = 30,
  pastDays = 30,
  limit = 100,
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["dashboard-upcoming-meetings", days, pastDays, limit],
    queryFn: () => getUpcomingMeetings({ days, pastDays, limit }),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};

export const useGetDealsSummary = () =>
  useQuery({
    queryKey: ["dashboard-deals-summary"],
    queryFn: getDealsSummary,
    staleTime: 60 * 1000,
  });

// get dashboard campaign performance hook
export const useGetDsahboardCampaignPerformance = (days) => {
  return useQuery({
    queryKey: ["dashboard-campaign-performance", days],
    queryFn: () => getDashboardCampaignPerformance(days),
    staleTime: 60 * 1000,
  });
};

// get top performing campaigns hook
export const useGetTopPerformingCampaigns = (days) => {
  return useQuery({
    queryKey: ["top-performing-campaigns", days],
    queryFn: () => getTopPerformingCampaigns(days),
    staleTime: 60 * 1000,
  });
};

// get channel effectiveness hook
export const useGetChannelEffectiveness = (days) => {
  return useQuery({
    queryKey: ["channel-effectiveness", days],
    queryFn: () => getChannelEffectiveness(days),
    staleTime: 60 * 1000,
  });
};

export const useGetAccountsDashboard = (days) => {
  return useQuery({
    queryKey: ["dashboard-accounts", days],
    queryFn: () => getAccountsDashboard(days),
    staleTime: 60 * 1000,
  });
};

export const useGetSimilarAccountTargets = (userId) => {
  return useQuery({
    queryKey: ["dashboard-similar-account-targets", userId],
    queryFn: getSimilarAccountTargets,
    enabled: Boolean(userId),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    // Optional widget: it shows its empty state; a toast on every focus would be noise.
    meta: { silentError: true },
  });
};
